import React from "react";
import { Box } from "@mui/material";
import { LockedIcon, SignedOffIcon } from "assets";
import { COLORS, Label14Medium } from "components";

export const ApprovalsActions = ({ value, id }: { value: "SIGN_OFF" | "LOCK", id: string }) => (
  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }} id={id}>
    {value === "SIGN_OFF" ? <SignedOffIcon color="#0E25D5" /> : <LockedIcon color="#1D1D1D" />}
    <Label14Medium id={id} sx={{ color: value === "SIGN_OFF" ? COLORS.Siggned_Off_Color : COLORS.Locked_Color }}>
      {value === "SIGN_OFF" ? "Signed Off" : "Locked"}
    </Label14Medium>
  </Box>
);
